import { ReactNode } from 'react';
import { PersonsLanesContextProvider, usePersonsTrackLanesState } from './usePersonsTrackLanes';

type PersonsLanesProviderProps = {
  children: ReactNode;
};

/**
 * Context provider for Personas track + tab lane data on the stream screen.
 *
 * Computes focus-clipped lanes and summary packing once and shares them with
 * {@link PersonsTrackGroup} and {@link PersonsContainer} so face/voice work is
 * not duplicated while both surfaces are mounted.
 */
export function PersonsLanesProvider({ children }: PersonsLanesProviderProps) {
  const value = usePersonsTrackLanesState();
  return <PersonsLanesContextProvider value={value}>{children}</PersonsLanesContextProvider>;
}
